/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import { object, func } from 'prop-types';
import { useDispatch } from 'react-redux';

import { emitCustomTrackingEvent } from '../../../../../../state/ducks/TagManager/ducks/ClickStreamEvents/ClickStreamEvent-Actions';
import useClickStreamCustomEventsTracking from '../../../../../helpers/Personalization/useClickstreamCustomEventsTracking';
import CollectionCarouselUI from './CollectionCarouselUI';
import CollectionGridUI from './CollectionGridUI';

const PersonalizedHPCollectionRecsContainer = ({
    data, setShowSkeleton,
}) => {
    const dispatch = useDispatch();
    const page = { type: 'home' };

    const campaignResponse = data?.campaign?.campaignResponses?.[0] || {};
    const minimumProductsToShow = campaignResponse?.payload?.minimumProductsToShow || 2;

    useClickStreamCustomEventsTracking({
        salesforceResponse: data,
        isFireImpression: campaignResponse?.experienceName === 'Control',
        page,
    });

    useEffect(() => {
        setShowSkeleton(false);
    }, []);

    useEffect(() => {
        if (data?.collections?.length > 0) {
            dispatch(emitCustomTrackingEvent({
                action: 'Impression',
                salesforceResponse: data,
                page,
                eventSubType: 'campaign-tracking',
                displayType: campaignResponse?.payload?.layoutDisplayType,
                minimumProductsToShow,
            }));
        }
    }, [data?.collections]);

    const trackClickThrough = (collectionId) => {
        dispatch(emitCustomTrackingEvent({
            action: 'Click',
            partNumber: collectionId,
            salesforceResponse: data,
            page,
            eventSubType: 'campaign-tracking',
            fromCollectionRecs: true,
        }));
    };

    if (data?.collections?.length > 0) {
        const cmsData = data?.content || {};
        const title = campaignResponse?.payload?.collectionRecTitle || campaignResponse?.payload?.fallbackCollectionRecTitle || cmsData?.main_title;
        const isGridView = campaignResponse?.payload?.layoutDisplayType === 'GRID';

        if (isGridView && (data?.collections?.length > data?.content?.number_of_products_per_row)) {
            return <CollectionGridUI title={title} trackClickThrough={trackClickThrough} data={data} />;
        }

        return <CollectionCarouselUI title={title} trackClickThrough={trackClickThrough} data={data} />;
    }

    return null;
};

PersonalizedHPCollectionRecsContainer.propTypes = {
    data: object.isRequired,
    setShowSkeleton: func.isRequired,
};

export default PersonalizedHPCollectionRecsContainer;
